import { createAsyncThunk } from '@reduxjs/toolkit';
import { NAV_BOOKMARKED_ITEMS_ATTR } from '../../constants/navPersona';
import { navPersonaService } from '../../services';
import { NAV_ITEM_BOOKMARKS_GROUP_ID } from '../../constants/Bookmarks';
export const bookmarksToPersonaApiAction = createAsyncThunk('navItems/to-persona-api', async (__, {
  getState
}) => {
  const {
    navItems,
    user
  } = getState();
  const ids = [];
  const entities = {};
  for (const bookmark of navItems.byId[NAV_ITEM_BOOKMARKS_GROUP_ID].children) {
    var _navItems$byId$bookma;
    ids.push(bookmark.id);
    entities[bookmark.id] = {
      id: bookmark.id,
      path: ((_navItems$byId$bookma = navItems.byId[bookmark.id]) === null || _navItems$byId$bookma === void 0 ? void 0 : _navItems$byId$bookma.path) || ''
    };
  }
  const serializedBookmarksState = JSON.stringify({
    ids,
    entities
  });
  return await navPersonaService.setAttribute(NAV_BOOKMARKED_ITEMS_ATTR, serializedBookmarksState, user.id);
});